import { render, staticRenderFns } from "./DicomCutItem.vue?vue&type=template&id=d6af3a34&scoped=true&"
import script from "./DicomCutItem.vue?vue&type=script&lang=js&"
export * from "./DicomCutItem.vue?vue&type=script&lang=js&"
import style0 from "./DicomCutItem.vue?vue&type=style&index=0&id=d6af3a34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6af3a34",
  null
  
)

export default component.exports